module.exports = __webpack_public_path__ + "static/img/scene8.2bbd366f.jpg";